import callAPiBase from './base';

const productApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/productList',
      method: 'GET',
      useToken: true,
      title: 'Product - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/productCreate',
      method: 'POST',
      useToken: true,
      title: 'Product - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/productUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Product - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/productDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Product - Delete',
      params,
    }),
};

export { productApi };
export default productApi;
